import { render, staticRenderFns } from "./QuizJoinGameForm.vue?vue&type=template&id=124d880c&scoped=true&"
import script from "./QuizJoinGameForm.vue?vue&type=script&lang=js&"
export * from "./QuizJoinGameForm.vue?vue&type=script&lang=js&"
import style0 from "./QuizJoinGameForm.vue?vue&type=style&index=0&id=124d880c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d880c",
  null
  
)

export default component.exports